export const DOCUMENT_PROVENANCE_CLASSES =
  'flex items-center gap-1.5 rounded-md border px-2 py-1.5 text-xs font-medium transition-colors focus:outline-none disabled:opacity-50 ' +
  'data-[focus]:outline data-[focus]:outline-2 data-[focus]:outline-offset-2 data-[focus]:outline-primary-500 ' +
  'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500 ' +
  'border-neutral-950/10 hover:border-neutral-950/20 dark:border-white/10 dark:hover:border-white/20';

export function DocumentProvenanceLabel({ label, name }: { label: string; name: string }) {
  return (
    <>
      <span>{label}</span> <span className="text-neutral-400 dark:text-neutral-500">·</span>{' '}
      <span className="max-w-48 truncate">{name}</span>
    </>
  );
}
